import { Icon } from "@iconify/react";
import { useEffect, useRef, useState } from "react";
import unlockFill from "@iconify/icons-eva/unlock-fill";
import personFill from "@iconify/icons-eva/person-fill";
import { useNavigate, useLocation } from "react-router-dom";
import { useSnackbar } from "notistack";
import ChangePassword from "./ChangePassword";
import { alpha } from "@mui/material/styles";
import {
  Button,
  Box,
  Divider,
  MenuItem,
  Typography,
  Avatar,
  IconButton,
} from "@mui/material";
import MenuPopover from "../../components/MenuPopover";
import { _get_user_from_localStorage } from "src/DAL/localStorage/localStorage";
import { s3baseUrl } from "src/config/config";
import { get_root_value } from "src/utils/domUtils";
import { useContentSetting } from "src/Hooks/ContentContext/ContentSettingState";
import { getForms_count } from "src/DAL/Forms/forms";
import { useChat } from "src/Hooks/ChatContext";

const MENU_OPTIONS = [
  {
    label: "Edit Profile",
    icon: personFill,
    linkTo: "/edit-profile",
  },
];

export default function AccountPopover() {
  const anchorRef = useRef(null);
  const navigate = useNavigate();
  const { STOP_SOCKET_FORCEFULLY, handleUnreadMessageCount } =
    useContentSetting();
  const { handleCloseChat } = useChat();
  const { pathname } = useLocation();
  const [openPasswordModal, setopenPasswordModal] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleProfile = (value) => {
    navigate(value);
    handleClose();
  };

  const { userInfo, setUserInfo } = useContentSetting();
  const handleGetCount = async () => {
    const result = await getForms_count();
    if (result.code === 200) {
      setUserInfo((values) => ({
        ...values,
        formcount: result?.pending_forms,
      }));
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleLogout = async () => {
    handleUnreadMessageCount(0);
    handleCloseChat();
    STOP_SOCKET_FORCEFULLY();
    localStorage.clear();
    navigate("/login");
  };

  const handleChange = () => {
    handleClose();
    navigate(`/dashboard`);
  };

  useEffect(() => {
    handleGetCount();
  }, [pathname]);

  useEffect(() => {
    setTimeout(() => {
      const is_path_includes = (path) => {
        return pathname.toString().includes(path);
      };
      if (!is_path_includes("/forms")) {
        localStorage.removeItem("UserFormSListSearch");
      }
      if (!is_path_includes("/programmes")) {
        localStorage.removeItem("difficultyLevel");
        localStorage.removeItem("isOpen");
      }
      if (
        !is_path_includes("/community-area") &&
        !is_path_includes("/my-posts")
      ) {
        localStorage.removeItem("selectedGroup");
      }
    }, 1000);
  }, [pathname]);

  return (
    <>
      <ChangePassword
        openPasswordModal={openPasswordModal}
        setopenPasswordModal={setopenPasswordModal}
      />
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            "&:before": {
              zIndex: 1,
              content: "''",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              position: "absolute",
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72),
            },
            color: get_root_value("--portal-theme-primary"),
          }),
        }}
      >
        {userInfo !== null &&
        userInfo !== undefined &&
        userInfo !== "undefined" ? (
          <Avatar
            src={s3baseUrl + userInfo?.profile_image}
            alt={userInfo?.first_name + " " + userInfo?.last_name}
          ></Avatar>
        ) : (
          ""
        )}
      </IconButton>

      <MenuPopover
        Popover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 220 }}
      >
        {userInfo !== null &&
        userInfo !== undefined &&
        userInfo !== "undefined" ? (
          <Box sx={{ my: 1.5, px: 2.5 }} onClick={handleChange} color="inherit">
            <Typography variant="subtitle1" noWrap>
              {userInfo?.first_name + " " + userInfo?.last_name}
            </Typography>
            <Typography variant="body2" noWrap>
              {userInfo?.email}
            </Typography>
          </Box>
        ) : (
          ""
        )}
        <Divider sx={{ my: 1 }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.label}
            onClick={() => handleProfile(option.linkTo)}
            sx={{ typography: "body2", py: 1, px: 2.5 }}
          >
            <Box
              component={Icon}
              icon={option.icon}
              sx={{
                mr: 2,
                width: 24,
                height: 24,
                color: get_root_value("--portal-theme-primary"),
              }}
            />

            {option.label}
          </MenuItem>
        ))}
        <MenuItem
          key=""
          onClick={() => {
            handleClose();
            setopenPasswordModal(true);
          }}
          sx={{ typography: "body2", py: 1, px: 2.5 }}
        >
          <Box
            component={Icon}
            icon={unlockFill}
            sx={{
              mr: 2,
              width: 24,
              height: 24,
              color: get_root_value("--portal-theme-primary"),
            }}
          />
          Change Password
        </MenuItem>
        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button
            fullWidth
            color="inherit"
            variant="outlined"
            onClick={() => handleLogout()}
          >
            Logout
          </Button>
        </Box>
      </MenuPopover>
    </>
  );
}
